import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";


export const Contact = () => {
  const { t } = useTranslation("contact");

  return (
    <Box maxWidth="sm" mx="auto" textAlign="center">
      <Box
        component="img"
        src="https://images.unsplash.com/photo-1525186402429-1ddb09b5d7a5"
        alt="Contact us"
        sx={{ width: '100%', height: 224, objectFit: 'cover', borderRadius: 2, boxShadow: 2, mb: 4 }}
      />
      <Typography variant="h4" gutterBottom>{t("contact.contact")}</Typography>
      <Typography variant="h6">{t("contact.contactText")}</Typography>
    </Box>
  );
};